import React, {useState} from "react";
import phoneGlyph from "../../assets/images/icons/phone-bubble-glyph.svg";
import closeTooltipIcon from "../../assets/images/icons/close.svg";
import analyitics from "../../utils/analytics";

function FloatingContactButton(props) {

    const [isTooltipVisible, setIsTooltipVisible] = useState(true);

    const buttonClickHandler = () => {
        analyitics.sendEvent({
            category: 'Pływająca słuchawka',
            action: 'Klikniecie',
            label: 'Kliknieto w pływającą słuchawkę',
            value: 1
        });

        setIsTooltipVisible(false);
        props.onClick();
    };

    const closeTooltipHandler = (event) => {
        event.stopPropagation();
        setIsTooltipVisible(false);
    };

    return (
        <div className="floating-contact">
            {isTooltipVisible && (
                <div className="floating-contact-tooltip" onClick={buttonClickHandler}>
                    <button
                        type="button"
                        className="floating-contact-tooltip-close"
                        onClick={closeTooltipHandler}
                        aria-label="Zamknij"
                    >
                        <img src={closeTooltipIcon} alt=""/>
                    </button>
                    <p className="floating-contact-tooltip-title">Masz pytanie?</p>
                    <p className="floating-contact-tooltip-text">Skontaktuj się z naszym doradcą.</p>
                </div>
            )}

            <button
                type="button"
                className="floating-contact-btn"
                onClick={buttonClickHandler}
                aria-label="Skontaktuj się"
            >
                <img src={phoneGlyph} alt="" className="floating-contact-btn-icon"/>
            </button>
        </div>
    );
}

export default FloatingContactButton;
